"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var AccountingDocument_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingDocument = exports.PaymentRemindersEnum = exports.PaymentReminderStatusEnum = exports.AccountingDocumentStatusEnum = exports.AccountingDocumentCategoryEnum = exports.AccountingDocumentTypeEnum = void 0;
const typeorm_1 = require("typeorm/browser");
const account_1 = require("../account");
const accounting_document_line_item_1 = require("./accounting-document-line-item");
const job_1 = require("../job");
const payment_record_1 = require("../payments/payment-record");
const events_1 = require("../../events");
const accounting_document_translation_1 = require("./accounting-document-translation");
const column_numeric_transformer_1 = require("../../transformers/column-numeric-transformer");
const hashable_1 = require("../../util/hashable");
const email_1 = require("../email");
const column_date_transformer_1 = require("../../transformers/column-date-transformer");
const class_transformer_1 = require("class-transformer");
const data_ui_1 = require("../../data-ui");
const layouts_1 = require("../../data-ui/layouts");
const contact_profile_enum_1 = require("../contact-profile-enum");
const user_role_enum_1 = require("../user-role-enum");
var AccountingDocumentTypeEnum;
(function (AccountingDocumentTypeEnum) {
    AccountingDocumentTypeEnum["INVOICE"] = "invoice";
    AccountingDocumentTypeEnum["CREDIT_NOTE"] = "credit_note";
})(AccountingDocumentTypeEnum = exports.AccountingDocumentTypeEnum || (exports.AccountingDocumentTypeEnum = {}));
var AccountingDocumentCategoryEnum;
(function (AccountingDocumentCategoryEnum) {
    AccountingDocumentCategoryEnum["PREPAYMENT"] = "prepayment";
})(AccountingDocumentCategoryEnum = exports.AccountingDocumentCategoryEnum || (exports.AccountingDocumentCategoryEnum = {}));
var AccountingDocumentStatusEnum;
(function (AccountingDocumentStatusEnum) {
    AccountingDocumentStatusEnum["DRAFT"] = "draft";
    AccountingDocumentStatusEnum["PENDING"] = "pending";
    AccountingDocumentStatusEnum["CREATED"] = "created";
    AccountingDocumentStatusEnum["SEND_PENDING"] = "send_pending";
    AccountingDocumentStatusEnum["SENT"] = "sent";
    AccountingDocumentStatusEnum["PAID"] = "paid";
    AccountingDocumentStatusEnum["RECEIVED"] = "received";
    AccountingDocumentStatusEnum["CANCELLATION_PENDING"] = "cancellation_pending";
    AccountingDocumentStatusEnum["CANCELLED"] = "cancelled";
    AccountingDocumentStatusEnum["CANCELLATION_SEND_PENDING"] = "cancellation_send_pending";
    AccountingDocumentStatusEnum["CANCELLATION_SENT"] = "cancellation_sent";
})(AccountingDocumentStatusEnum = exports.AccountingDocumentStatusEnum || (exports.AccountingDocumentStatusEnum = {}));
var PaymentReminderStatusEnum;
(function (PaymentReminderStatusEnum) {
    PaymentReminderStatusEnum["INVOICE_SENT"] = "invoice-sent";
    PaymentReminderStatusEnum["FIRST_REMINDER_SENT"] = "first-reminder-sent";
    PaymentReminderStatusEnum["SECOND_REMINDER_SENT"] = "second-reminder-sent";
    PaymentReminderStatusEnum["THIRD_REMINDER_SENT"] = "third-reminder-sent";
})(PaymentReminderStatusEnum = exports.PaymentReminderStatusEnum || (exports.PaymentReminderStatusEnum = {}));
var PaymentRemindersEnum;
(function (PaymentRemindersEnum) {
    PaymentRemindersEnum["SEND_DOCUMENT"] = "send_document";
    PaymentRemindersEnum["FIRST_REMINDER"] = "first_reminder";
    PaymentRemindersEnum["SECOND_REMINDER"] = "second_reminder";
    PaymentRemindersEnum["THIRD_REMINDER"] = "third_reminder";
})(PaymentRemindersEnum = exports.PaymentRemindersEnum || (exports.PaymentRemindersEnum = {}));
let AccountingDocument = AccountingDocument_1 = class AccountingDocument {
    get vatAmount() {
        var _a;
        return this.reverseVatCharge
            ? 0
            : (_a = this.lineItems) === null || _a === void 0 ? void 0 : _a.reduce((sum, lineItem) => sum + (lineItem['vatRate'] / 100) * lineItem['totalPrice'], 0);
    }
    get vatRate() {
        var _a;
        return this.reverseVatCharge
            ? new Set([0])
            : new Set((_a = this.lineItems) === null || _a === void 0 ? void 0 : _a.map((lineItem) => {
                return lineItem['vatRate'];
            }));
    }
    get isDocumentCreationDelayed() {
        var _a, _b;
        return (((_a = this.target) === null || _a === void 0 ? void 0 : _a.accountingPerJob) &&
            ((_b = this.target) === null || _b === void 0 ? void 0 : _b.role) === user_role_enum_1.UserRoleEnum.PARTNER &&
            this.type == AccountingDocumentTypeEnum.CREDIT_NOTE &&
            (typeof this.daysSinceInvoicesSent === 'number'
                ? this.daysSinceInvoicesSent <
                    AccountingDocument_1.CREDIT_NOTE_DELAY_DAYS_AFTER_INVOICE
                : typeof this.daysSinceJobsCompleted === 'number'
                    ? this.daysSinceJobsCompleted <
                        AccountingDocument_1.CREDIT_NOTE_DELAY_DAYS_AFTER_COMPLETED
                    : false));
    }
    asHashableContent() {
        var _a, _b, _c, _d;
        return {
            target: (_b = (_a = this.target) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString(),
            currencySymbol: (_c = this.currencySymbol) === null || _c === void 0 ? void 0 : _c.toString(),
            vatAmount: (0, hashable_1.numToString)(this.vatAmount),
            totalAmount: (0, hashable_1.numToString)(this.totalAmount),
            lineItems: (_d = this.lineItems) === null || _d === void 0 ? void 0 : _d.map((item) => {
                var _a, _b, _c, _d, _e;
                return ({
                    jobNumber: (_a = item.jobNumber) === null || _a === void 0 ? void 0 : _a.toString(),
                    externalOrderId: (_b = item.externalOrderId) === null || _b === void 0 ? void 0 : _b.toString(),
                    deliveryDate: (0, hashable_1.dateToDateString)(item.deliveryDate),
                    description: (_c = item.description) === null || _c === void 0 ? void 0 : _c.toString(),
                    quantity: (0, hashable_1.numToString)(item.quantity),
                    unitPrice: (0, hashable_1.numToString)(item.unitPrice),
                    totalPrice: (0, hashable_1.numToString)(item.totalPrice),
                    vatRate: (0, hashable_1.numToString)(item.vatRate),
                    invoicingTarget: (_d = item.invoicingTarget) === null || _d === void 0 ? void 0 : _d.toString(),
                    targetType: (_e = item.targetType) === null || _e === void 0 ? void 0 : _e.toString(),
                });
            }),
        };
    }
};
AccountingDocument.EVENTS = (0, events_1.makeEventsForClass)(AccountingDocument_1, AccountingDocumentStatusEnum);
AccountingDocument.CREDIT_NOTE_DELAY_DAYS_AFTER_INVOICE = 14;
AccountingDocument.CREDIT_NOTE_DELAY_DAYS_AFTER_COMPLETED = 30;
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: AccountingDocumentTypeEnum,
        nullable: false,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: AccountingDocumentCategoryEnum,
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "category", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)('boolean', {
        nullable: false,
        default: false,
    }),
    __metadata("design:type", Boolean)
], AccountingDocument.prototype, "inverse", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: AccountingDocumentStatusEnum,
        nullable: false,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "status", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)((type) => account_1.Account, {
        eager: true,
    }),
    __metadata("design:type", account_1.Account)
], AccountingDocument.prototype, "target", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: false,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "number", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        unique: true,
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "outsideCommunicationNumber", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'date',
        transformer: new column_date_transformer_1.ColumnDateTransformer(),
    }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], AccountingDocument.prototype, "issueDate", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 3,
        nullable: false,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "currencySymbol", void 0);
__decorate([
    (0, typeorm_1.Column)('int', {
        nullable: true,
        name: 'due_days',
    }),
    __metadata("design:type", Number)
], AccountingDocument.prototype, "dueDays", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'date',
        nullable: true,
        transformer: new column_date_transformer_1.ColumnDateTransformer(),
    }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], AccountingDocument.prototype, "dueDate", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], AccountingDocument.prototype, "totalAmount", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'numeric',
        nullable: true,
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], AccountingDocument.prototype, "materialCostsAmount", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'numeric',
        nullable: true,
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], AccountingDocument.prototype, "installationCostsAmount", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'numeric',
        nullable: true,
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], AccountingDocument.prototype, "prepaidAmount", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'numeric',
        nullable: true,
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], AccountingDocument.prototype, "amountToPay", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "path", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "purchaseOrderNumber", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "cancellationNumber", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "cancellationPath", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'date',
        nullable: true,
    }),
    __metadata("design:type", Date)
], AccountingDocument.prototype, "cancellationDate", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'bool',
        default: false,
    }),
    __metadata("design:type", Boolean)
], AccountingDocument.prototype, "reverseVatCharge", void 0);
__decorate([
    (0, typeorm_1.Column)({
        default: false,
    }),
    __metadata("design:type", Boolean)
], AccountingDocument.prototype, "auto", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: PaymentReminderStatusEnum,
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingDocument.prototype, "paymentReminderStatus", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], AccountingDocument.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], AccountingDocument.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => accounting_document_line_item_1.AccountingDocumentLineItem, (item) => item.document, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], AccountingDocument.prototype, "lineItems", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], AccountingDocument.prototype, "vatAmount", null);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Set),
    __metadata("design:paramtypes", [])
], AccountingDocument.prototype, "vatRate", null);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM, layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.OneToMany)((type) => accounting_document_translation_1.AccountingDocumentTranslation, (item) => item.document, {
        cascade: true,
    }),
    __metadata("design:type", Array)
], AccountingDocument.prototype, "translations", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => job_1.Job, {
        eager: true,
    }),
    (0, typeorm_1.JoinTable)({
        name: 'accounting_document_to_jobs',
    }),
    __metadata("design:type", Array)
], AccountingDocument.prototype, "jobs", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => payment_record_1.PaymentRecord, (payment) => payment.documents),
    (0, typeorm_1.JoinTable)(),
    __metadata("design:type", Array)
], AccountingDocument.prototype, "payments", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => email_1.Email, (email) => email.accountingDocuments),
    __metadata("design:type", Array)
], AccountingDocument.prototype, "emails", void 0);
AccountingDocument = AccountingDocument_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [],
    }),
    data_ui_1.DataUi.Name({
        name: 'AccountingDocument',
        nameProperties: ['number'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('accounting_document', { schema: 'accounting' }),
    (0, typeorm_1.Check)('gid_accounting_document_unique_number_check(id, inverse, target_id, number, status::text)')
], AccountingDocument);
exports.AccountingDocument = AccountingDocument;
//# sourceMappingURL=accounting-document.js.map